import React from "react";
import PropTypes from "prop-types";

import groupBy from "../../../utils/groupBy";
import {useQuotes} from "../QuotesContext";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ListSubheader from "@mui/material/ListSubheader";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Skeleton from "@mui/material/Skeleton";
import CircleIcon from '@mui/icons-material/Circle';


const ApartmentSelect = (props) => {
    const {bookingVariantsQuery, SelectProps = {}, ...TextFieldProps} = props;
    const {accommodations} = useQuotes();
    const accommodationUnits = accommodations.accommodationUnits;

    const availableApartmentsPrices = bookingVariantsQuery.data?.pricesInfo?.availableApartmentsPrices;
    const availableApartmentIdsSet = availableApartmentsPrices ?
        new Set(availableApartmentsPrices.map(a => a.apartmentId))
        :
        new Set();

    const groupedApartments = groupBy(
        accommodationUnits.sort(
            (a, b) => (
                (Number(availableApartmentIdsSet.has(b.id)) - Number(availableApartmentIdsSet.has(a.id)))
                || a.name.localeCompare(b.name)
            )),
            a => a.accommodation.name
    );

    return (accommodations.isLoading || bookingVariantsQuery.isLoading ?
            <Stack flexGrow={1}> <Skeleton height={72}/> </Stack>
            :
            <TextField select
                       fullWidth
                       SelectProps={{
                           displayEmpty: true,
                           renderValue: (value) => {
                               if (value !== "") {
                                   const apartment = accommodations.findApartment(value);
                                   return <Stack>
                                       <Typography variant="body1" fontWeight="normal" noWrap>
                                           {apartment?.name || ""}
                                       </Typography>
                                       <Typography variant="caption" fontWeight="normal" noWrap>
                                           {apartment?.home?.name || ""}
                                       </Typography>
                                       <AvailabilityStatus available={availableApartmentIdsSet.has(apartment?.id)}/>
                                   </Stack>
                               } else {
                                   return <Typography color="text.primary">
                                       Seleziona struttura
                                   </Typography>
                               }
                           },
                           ...SelectProps
                       }}
                       {...TextFieldProps}>
                {
                    accommodationUnits.length === 0 &&
                    <MenuItem key="no-option" disabled>
                        Nessuna struttura presente
                    </MenuItem>
                }

                {Object.entries(groupedApartments).flatMap(([homeName, units]) => (
                    [
                        <ListSubheader key={homeName} value="">
                            {homeName}
                        </ListSubheader>,
                        ...units.map(a => (
                            <MenuItem key={a.id} value={a.id}>
                                <Stack>
                                    <Typography>{a.name}</Typography>
                                    <AvailabilityStatus available={availableApartmentIdsSet.has(a.id)}/>
                                </Stack>
                            </MenuItem>
                        ))
                    ]
                ))}
            </TextField>
    )
}

const AvailabilityStatus = ({available}) => {

    return <Typography variant="caption" fontWeight="light">
        {
            available ?
                <><CircleIcon sx={{fontSize: "8px"}} color="success"/> Disponibile</>
                :
                <><CircleIcon sx={{fontSize: "8px"}} color="error"/> Occupato</>
        }
    </Typography>
}

ApartmentSelect.propTypes = {
    props: PropTypes.object,  // any properties of a TextField component
}

export default ApartmentSelect;
